<template>
  <div>
    <icon-defs></icon-defs>

    <sticky-alert @click="visible = true"></sticky-alert>

 <sticky-alert2 @click="redirectToDriverSearch"></sticky-alert2>


    <site-navbar></site-navbar>

    <client-only>
      <alert-modal @store="alertRedirect" v-model:visible="visible" />
      <reservation-modal />
       <driver-reservation-modal />
      <ConfirmDialog group="confirmation">
        <template #message="slotProps">
          <div class="border-bottom-1 flex w-full flex-col items-center gap-5">
            <i style="font-size: 3rem" :class="slotProps.message.icon"></i>

            <p>{{ slotProps.message.message }}</p>
          </div>
        </template>
      </ConfirmDialog>
    </client-only>

    <slot></slot>
    <div  class="floating-call-container">
    <div v-if="isVisible" class="message-box">
      <span>Funargos publie vos trajets pour vous ! Contactez nous !</span>
      <button class="close-button" @click="toggleVisibility">✖</button>
    </div>
    <div class="call-icon" @click="makeCall">
      <!-- Use an icon, such as Font Awesome, or place an SVG/emoji here -->
      <span class="icon">🎧</span>
    </div>
  </div>
    <site-footer></site-footer>
  </div>
</template>

<script setup>
import Dialog from "primevue/dialog";

const router = useRouter();
const visible = ref(false);
const { $listen, $unListen } = useNuxtApp();
import { useAuthStore } from "~/store/auth";

const authStore = useAuthStore();

let interval = ref(null);
const isVisible = ref(true);

// Start interval when user is authenticated (authStore.isAuthenticated) for fetching notifications periodically
const toggleVisibility = () => {
  isVisible.value = !isVisible.value;
};

// Function to handle the call action
const makeCall = () => {
  // Example: Open phone dialer or execute a different action
  window.location.href = "tel:+330458174065"; // Replace with actual phone number or action
};

watch(
  () => authStore.isAuthenticated,
  (isAuthenticated) => {
    if (isAuthenticated) {
      interval.value = setInterval(() => {
        authStore.fetchNotifications();
      }, 30000);
    } else {
      clearInterval(interval.value);
    }
  }, // watch options
  { immediate: true }
);

// on mounted listen to event

useHead({
  title: "Funargos",
  viewport: "width=device-width, initial-scale=1, maximum-scale=1",
  charset: "utf-8",

  meta: [
    {
      name: "description",
      content: "Mise en relation des chauffeurs funéraires",
    },
  ],
});

const onOpenCreateAlert = () => {
  visible.value = true;
};

onMounted(() => {
  $listen("open-create-alert", onOpenCreateAlert);
});

onBeforeUnmount(() => {
  $unListen("open-create-alert", onOpenCreateAlert);
});

 const redirectToDriverSearch= () => {
      router.push({ path: '/votre-un-trajet' });
    };

const alertRedirect = () => {
  visible.value = false;
  router.push({
    path: "/dashboard/mes-alertes",
  });
};
</script>
<style scoped>
.dialog {
  padding: 0 !important;
}
.floating-call-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.message-box {
  background-color: #1b2a4e; /* Customize this color */
  color: #fff;
  border-radius: 30px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

.close-button {
  background: none;
  border: none;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  margin-left: 10px;
  cursor: pointer;
}

.call-icon {
  background-color: #1b2a4e; /* Customize this color */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
}

.icon {
  font-size: 24px;
}
</style>
